var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "documentTagsModal",
    attrs: {
      "modal-dialog-scrollable": false,
      "footer-close-button": false,
      "modal-dialog-size": "lg",
    },
    on: { hidden: _vm.cleanValues, show: _vm.initValues },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("documents.manageDocumentLabels")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("documents.useTheAreBellowToManageYourLabels")
                  ) +
                  ","
              ),
              _c("b", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("documents.youCanClickAnyFieldToEdit"))
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", lg: "6" } },
                  [
                    _c("document-tags-table", {
                      ref: "userLabelsTable",
                      attrs: {
                        title: _vm.$t("documents.userLabels"),
                        data: _vm.USER_DOCUMENT_LABELS,
                      },
                      on: {
                        edit: function ($event) {
                          return _vm.editLabel($event, false)
                        },
                        preEdit: function ($event) {
                          return _vm.preEditLabel($event, false)
                        },
                        delete: _vm.deleteUserLabel,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "12", lg: "6" } },
                  [
                    _c("document-tags-table", {
                      ref: "brokerageLabelsTable",
                      attrs: {
                        title: _vm.$t("documents.brokerageLabels"),
                        data: _vm.BROKERAGE_DOCUMENT_LABELS,
                      },
                      on: {
                        edit: function ($event) {
                          return _vm.editLabel($event, true)
                        },
                        preEdit: function ($event) {
                          return _vm.preEditLabel($event)
                        },
                        delete: _vm.deleteBrokerLabel,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function (ref) {
          var close = ref.close
          return [
            _c(
              "div",
              { staticClass: "w-100" },
              [
                _c(
                  "b-row",
                  { staticClass: "py-3 align-items-center" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "6", lg: "3" } },
                      [
                        _c("material-input", {
                          staticClass: "mb-0",
                          attrs: {
                            label: _vm.$t("global.words.name"),
                            "on-type": "",
                          },
                          model: {
                            value: _vm.newLabel.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.newLabel, "name", $$v)
                            },
                            expression: "newLabel.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "pl-0", attrs: { cols: "6", lg: "3" } },
                      [
                        _c(
                          "b-row",
                          { staticClass: "justify-content-center" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "theme-colorpicker",
                                attrs: { cols: "10" },
                              },
                              [
                                _c("colorpicker", {
                                  staticClass: "b-0",
                                  attrs: { color: _vm.newLabel.colour },
                                  on: {
                                    "update:color": function ($event) {
                                      return _vm.$set(
                                        _vm.newLabel,
                                        "colour",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "mt-2", attrs: { cols: "6", lg: "3" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-jelly p-smooth p-curve mr-0",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newLabel.shared,
                                  expression: "newLabel.shared",
                                },
                              ],
                              staticClass: "checkbox",
                              attrs: {
                                id: "shared-with-brokerage",
                                type: "checkbox",
                                name: "shared-with-brokerage",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.newLabel.shared)
                                  ? _vm._i(_vm.newLabel.shared, null) > -1
                                  : _vm.newLabel.shared,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.newLabel.shared,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.newLabel,
                                          "shared",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.newLabel,
                                          "shared",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.newLabel, "shared", $$c)
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "state p-success" },
                              [
                                _c("icon", {
                                  attrs: {
                                    name: "check",
                                    "icon-class": "icon",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "shared-with-brokerage" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "documents.sharedWithWholeBrokerage"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "d-flex justify-content-end justify-content-lg-center mt-2 mt-lg-0",
                        attrs: { cols: "6", lg: "3" },
                      },
                      [
                        _c(
                          "simple-button",
                          {
                            attrs: {
                              type: "primary",
                              "class-name": "btn-sm",
                              disabled: _vm.$v.$invalid,
                              loading: _vm.creating,
                              "loading-succeeded": _vm.creatingSucceeded,
                            },
                            on: { click: _vm.handleCreateTag },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.words.create")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-sm ml-3",
                            attrs: { variant: "white" },
                            on: {
                              click: function ($event) {
                                return close()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.words.close")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }